// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3daae89e","839":"1ac3bc17"}[chunkId] + ".chunk.js";
};